import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Auth } from 'src/app/models/auth';

import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { Router } from '@angular/router';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { DonationsService } from 'src/app/services/donations.service';

@Component({
  selector: 'app-doacoes',
  templateUrl: './doacoes.component.html',
  styleUrls: ['./doacoes.component.css']
})
export class DoacoesComponent implements OnInit {

  private currentUser: Auth;
  public donations: number = 0;
  constructor(
    private authenticationService: AuthenticationService,
    private donationsService: DonationsService,
    private alertService: NewAlertService,
    private router: Router) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getDonations();
  }

  details() {
    this.router.navigate(['']);
  }

  getDonations(){
    this.donationsService.getDonations(this.currentUser.token.assignorGuid).subscribe(
      response => {
        if(response.status === ApiError.Sucesso){
          this.donations = response.result;
        }
      }, error => {this.alertService.error(error.error)}
    )
  }
}
